export default () => {
    return (
        <div className="advt-right">
            <div className="advt-item">
                <iframe className="na" frameBorder="0" scrolling="no" width="300" height="250"
                        sandbox="allow-scripts allow-popups allow-forms allow-same-origin"
                        src="//a.o333o.com/api/spots/53908?p=1" />
            </div>
            <div className="advt-item">
                <iframe className="na" frameBorder="0" scrolling="no" width="300" height="250"
                        sandbox="allow-scripts allow-popups allow-forms allow-same-origin"
                        src="//a.o333o.com/api/spots/53909?p=1" />
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// components/ads/NTV.js